"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _MerchantForm = _interopRequireDefault(require("./components/MerchantForm"));
var _throttle = _interopRequireDefault(require("@/utils/throttle"));
var _SyncConfigDialog = _interopRequireDefault(require("./components/SyncConfigDialog"));
var _AsyncExportButton = _interopRequireDefault(require("@/components/AsyncExportButton"));
var _rsManagement = require("@/api/rsManagement");
var dangaoActApi = _interopRequireWildcard(require("@/api/dangaoActApi"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'MerchantList',
  components: {
    MerchantForm: _MerchantForm.default,
    SyncConfigDialog: _SyncConfigDialog.default,
    AsyncExportButton: _AsyncExportButton.default
  },
  data: function data() {
    return {
      loading: false,
      filterForm: {
        searchType: 'merchantName',
        searchValue: '',
        company: '',
        cooperationStatus: '',
        maintainer: '',
        dataSource: ''
      },
      companyOptions: [],
      cooperationStatusOptions: [{
        value: '1',
        label: '待联系'
      }, {
        value: '2',
        label: '初次联系无回复'
      }, {
        value: '3',
        label: '资料收集'
      }, {
        value: '4',
        label: '商务洽谈'
      }, {
        value: '5',
        label: '签订合同'
      }, {
        value: '6',
        label: '合同终止'
      }],
      maintainerOptions: [],
      tableData: [],
      selectedRows: [],
      pagination: {
        page: 1,
        size: 10,
        total: 0
      },
      dialogVisible: false,
      isEdit: false,
      dataSource: '',
      currentRow: null,
      syncLoading: false,
      // 同步参数配置弹窗
      syncConfigVisible: false,
      deliveryTemplates: [],
      regionOptions: [],
      // 默认配置数据（回显）
      defaultConfig: {}
    };
  },
  computed: {
    supplierExportParams: function supplierExportParams() {
      var params = {
        merchantName: this.filterForm.searchType === 'merchantName' ? this.filterForm.searchValue : undefined,
        company: this.filterForm.company,
        cooperationStatus: this.filterForm.cooperationStatus,
        maintainer: this.filterForm.maintainer,
        dataSource: this.filterForm.dataSource,
        businessType: this.filterForm.businessType,
        merchantId: this.filterForm.searchType === 'merchantId' ? this.filterForm.searchValue : undefined
      };
      return Object.keys(params).reduce(function (result, key) {
        if (params[key] !== undefined && params[key] !== '') {
          result[key] = params[key];
        }
        return result;
      }, {});
    },
    dialogTitle: function dialogTitle() {
      return this.isEdit ? '编辑商户' : '添加商户';
    }
  },
  mounted: function mounted() {
    this.getList();
    // 预加载下拉选项
    this.loadCompanyOptions();
    this.getSelectUser();
    // 预加载同步配置所需的下拉
    this.loadDeliveryTemplates();
    this.loadRegionOptions();
    // 预取一次默认配置，打开弹窗时可直接回显
    this.fetchDefaultConfig();
  },
  methods: {
    throttle: _throttle.default,
    // 获取列表数据
    getList: function getList() {
      var _this = this;
      this.loading = true;

      // 构建搜索参数
      var searchParams = {
        page: this.pagination.page,
        limit: this.pagination.size,
        company: this.filterForm.company,
        cooperationStatus: this.filterForm.cooperationStatus,
        maintainer: this.filterForm.maintainer,
        dataSource: this.filterForm.dataSource
      };

      // 根据搜索类型添加相应的搜索字段
      if (this.filterForm.searchValue) {
        searchParams[this.filterForm.searchType] = this.filterForm.searchValue;
      }
      Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/api/rsApi'));
      }).then(function (_ref) {
        var getSupplierList = _ref.getSupplierList;
        getSupplierList(searchParams).then(function (data) {
          // request拦截器已处理响应结构，直接使用data
          _this.tableData = data.list || [];
          _this.pagination.total = data.total || 0;
          _this.loading = false;
        }).catch(function (error) {
          _this.$message.error(error.message || '获取数据失败');
          _this.loading = false;
        });
      });
    },
    // 获取状态类型
    getStatusType: function getStatusType(status) {
      var statusMap = {
        '签订合同': 'success',
        '洽谈中': 'warning',
        '已停用': 'danger'
      };
      return statusMap[status] || 'info';
    },
    // 搜索
    handleSearch: function handleSearch() {
      this.pagination.page = 1;
      this.getList();
    },
    // 重置筛选
    resetFilter: function resetFilter() {
      this.filterForm = {
        searchType: 'merchantName',
        searchValue: '',
        company: '',
        cooperationStatus: '',
        maintainer: '',
        dataSource: ''
      };
      this.handleSearch();
    },
    // 处理搜索类型变化
    handleSearchTypeChange: function handleSearchTypeChange() {
      this.filterForm.searchValue = '';
    },
    // 获取搜索占位符
    getSearchPlaceholder: function getSearchPlaceholder() {
      var placeholderMap = {
        merchantName: '请输入商户名称',
        loginAccount: '请输入登录账号',
        wechatGroupName: '请输入微信群名称'
      };
      return placeholderMap[this.filterForm.searchType] || '请输入搜索内容';
    },
    // 加载归属公司选项
    loadCompanyOptions: function loadCompanyOptions(keyword) {
      var _this2 = this;
      Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/api/suplierCouponsApi'));
      }).then(function (_ref2) {
        var getAllCompany = _ref2.getAllCompany;
        getAllCompany(keyword).then(function (res) {
          _this2.companyOptions = res || [];
        }).catch(function (error) {
          console.warn('获取公司选项失败:', error.message);
        });
      });
    },
    // 加载维护人选项 - 参考供应商页面的实现
    getSelectUser: function getSelectUser(keyWord) {
      var _this3 = this;
      this.maintainerOptions = [];
      Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/api/suplierCouponsApi'));
      }).then(function (_ref3) {
        var getAllUser = _ref3.getAllUser;
        getAllUser(keyWord).then(function (res) {
          _this3.maintainerOptions = res || []; // flag: 1表示当前登陆人
        }).catch(function (error) {
          console.warn('获取维护人选项失败:', error.message);
        });
      });
    },
    // 处理用户搜索（维护人）- 参考供应商页面实现
    handleUserSearch: function handleUserSearch(data) {
      var _this4 = this;
      this.throttle(function () {
        _this4.getSelectUser(data);
      }, 300)();
    },
    // 处理公司搜索
    handleCompanySearch: function handleCompanySearch(keyword) {
      var _this5 = this;
      this.throttle(function () {
        _this5.loadCompanyOptions(keyword);
      }, 300)();
    },
    // 添加
    handleAdd: function handleAdd() {
      this.isEdit = false;
      this.currentRow = null;
      this.dialogVisible = true;
    },
    // 编辑
    handleEdit: function handleEdit(row) {
      this.isEdit = true;
      this.dataSource = row.dataSource;
      this.currentRow = _objectSpread({}, row);
      this.dialogVisible = true;
    },
    // 查看详情
    handleView: function handleView(row) {
      this.$router.push({
        path: '/rs/merchant/detail',
        query: {
          id: row.id
        }
      });
    },
    // 删除
    handleDelete: function handleDelete(row) {
      var _this6 = this;
      this.$confirm('确定要删除这条商户记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/api/rsApi'));
        }).then(function (_ref4) {
          var deleteSupplier = _ref4.deleteSupplier;
          deleteSupplier(row.id).then(function (data) {
            // request拦截器已处理响应结构，直接使用data
            _this6.$message.success('删除成功');
            _this6.getList();
          }).catch(function (error) {
            _this6.$message.error(error.message || '删除失败');
          });
        });
      }).catch(function () {
        _this6.$message.info('已取消删除');
      });
    },
    // 表格选择
    handleSelectionChange: function handleSelectionChange(selection) {
      this.selectedRows = selection;
    },
    // 分页
    handleSizeChange: function handleSizeChange(val) {
      this.pagination.size = val;
      this.pagination.page = 1;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pagination.page = val;
      this.getList();
    },
    // 保存
    handleSave: function handleSave(formData) {
      var _this7 = this;
      this.loading = true;
      // 模拟保存操作
      setTimeout(function () {
        _this7.$message.success(_this7.isEdit ? '编辑成功' : '添加成功');
        _this7.dialogVisible = false;
        _this7.loading = false;
        _this7.getList();
      }, 1000);
    },
    // 关闭弹窗
    handleCloseDialog: function handleCloseDialog() {
      this.dialogVisible = false;
      this.currentRow = null;
    },
    // 处理同步命令
    handleSyncCommand: function handleSyncCommand(command) {
      switch (command) {
        case 'fullSync':
          this.handleFullSync();
          break;
        case 'syncConfig':
          this.handleSyncConfig();
          break;
        default:
          console.warn('未知的同步命令:', command);
      }
    },
    // 打开同步参数配置弹窗
    handleSyncConfig: function handleSyncConfig() {
      // 打开前确保下拉数据可用
      if (!this.deliveryTemplates || this.deliveryTemplates.length === 0) {
        this.loadDeliveryTemplates();
      }
      if (!this.regionOptions || this.regionOptions.length === 0) {
        this.loadRegionOptions();
      }
      // 打开前刷新一次默认配置
      this.fetchDefaultConfig();
      this.syncConfigVisible = true;
    },
    // 接收子组件提交的数据
    handleSyncCompleted: function handleSyncCompleted(payload) {
      var _this8 = this;
      // 调用保存接口
      Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/api/merchantDefaultConfigApi'));
      }).then(function (_ref5) {
        var saveMerchantDefaultConfig = _ref5.saveMerchantDefaultConfig;
        saveMerchantDefaultConfig(payload).then(function () {
          _this8.$message.success('保存成功');
          _this8.fetchDefaultConfig();
        }).catch(function (error) {
          _this8.$message.error(error.message || '保存失败');
        });
      });
    },
    // 全量同步
    handleFullSync: function handleFullSync() {
      var _this9 = this;
      this.$confirm('确定要执行全量同步吗？此操作会同步所有商户和门店数据，可能需要较长时间。', '确认同步', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'sync-confirm-dialog'
      }).then(function () {
        _this9.syncLoading = true;
        Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/api/rsApi'));
        }).then(function (_ref6) {
          var triggerFullSync = _ref6.triggerFullSync;
          triggerFullSync().then(function (data) {
            _this9.$message.success(data || '全量同步任务已启动，请查看日志了解执行结果');
            _this9.getList(); // 刷新列表
          }).catch(function (error) {
            _this9.$message.error(error.message || '触发全量同步失败');
          }).finally(function () {
            _this9.syncLoading = false;
          });
        });
      }).catch(function () {
        _this9.$message.info('已取消同步');
      });
    },
    // 获取活跃商户数量
    getActiveCount: function getActiveCount() {
      return this.tableData.filter(function (item) {
        return item.cooperationStatus === '签订合同';
      }).length;
    },
    // 获取公司名称
    getCompanyName: function getCompanyName(companyId) {
      var company = this.companyOptions.find(function (item) {
        return item.id === companyId;
      });
      return company ? company.name : companyId;
    },
    // 获取合作状态名称
    getCooperationStatusName: function getCooperationStatusName(statusValue) {
      var status = this.cooperationStatusOptions.find(function (item) {
        return item.value === statusValue;
      });
      return status ? status.label : statusValue;
    },
    // 获取维护人名称
    getMaintainerName: function getMaintainerName(maintainerId) {
      var maintainer = this.maintainerOptions.find(function (item) {
        return item.id === maintainerId;
      });
      return maintainer ? maintainer.realName : maintainerId;
    },
    // 获取状态图标
    getStatusIcon: function getStatusIcon(status) {
      var iconMap = {
        '签订合同': 'el-icon-success',
        '洽谈中': 'el-icon-warning',
        '已停用': 'el-icon-error'
      };
      return iconMap[status] || 'el-icon-info';
    },
    // 格式化金额
    formatAmount: function formatAmount(amount) {
      if (!amount) return '0.00';
      return Number(amount).toLocaleString('zh-CN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    // 格式化日期时间
    formatDateTime: function formatDateTime(dateTime) {
      if (!dateTime) return '-';
      var date = new Date(dateTime);
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });
    },
    // 获取调价方式名称
    getAdjustTypeName: function getAdjustTypeName(isAdjust) {
      return isAdjust === 1 ? '按比例' : '不调价';
    },
    // 获取调价范围名称
    getAdjustRangeName: function getAdjustRangeName(adjustType) {
      var rangeMap = {
        1: '不超过原价',
        2: '不限制'
      };
      return rangeMap[adjustType] || '-';
    },
    // 格式化调价比例
    formatAdjustRate: function formatAdjustRate(adjustRate) {
      if (adjustRate === null || adjustRate === undefined || adjustRate === '') {
        return '0.00';
      }
      // 后端存储小数，前端也直接显示小数，最多保留两位小数
      return Number(adjustRate).toFixed(2);
    },
    // 加载配送模板（用于同步配置弹窗）
    loadDeliveryTemplates: function loadDeliveryTemplates() {
      var _this0 = this;
      var keyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      (0, _rsManagement.getShippingTemplateList)({
        keyword: keyword
      }).then(function (res) {
        // 期望 [{ id, name }]
        if (Array.isArray(res)) {
          // 如果返回的是 {key,value} 列表，做一层兼容
          _this0.deliveryTemplates = res.map(function (item) {
            return {
              id: item.id != null ? item.id : item.key,
              name: item.name != null ? item.name : item.value
            };
          });
        } else {
          _this0.deliveryTemplates = [];
        }
      }).catch(function () {
        _this0.deliveryTemplates = [];
      });
    },
    // 加载地区级联数据（用于同步配置弹窗）
    loadRegionOptions: function loadRegionOptions() {
      var _this1 = this;
      dangaoActApi.getShopSelfAddress().then(function (res) {
        _this1.regionOptions = res || [];
      }).catch(function () {
        _this1.regionOptions = [];
      });
    },
    // 获取后端默认配置并保存到 defaultConfig
    fetchDefaultConfig: function fetchDefaultConfig() {
      var _this10 = this;
      Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/api/merchantDefaultConfigApi'));
      }).then(function (_ref7) {
        var getMerchantDefaultConfig = _ref7.getMerchantDefaultConfig;
        getMerchantDefaultConfig().then(function (res) {
          _this10.defaultConfig = res || {};
        }).catch(function () {
          _this10.defaultConfig = {};
        });
      });
    }
  }
};